
import * as sdkclaro from '@claro/sdkclaromicrofront';
import { trimMobileNumber, uniqueBy, b64DecodeUnicode } from '../../components/organisms/ClaroList/utils'
import { calculateCommissions } from '../../components/organisms/GenericForm/utils/calculateCommissions'

let coords = {latitude: '0.0', longitude: '0.0'}

export const ClaroSDKService = {

    getPaymentConf() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getpaymentServicesConfig((result) => {
                    resolve(result)
                }, (error) => {
                    reject(error)
                })
            } catch (error) {
                reject(error)
            }
        })
    },
    sendDataPayment(data) {
        //var {destAccountId, destAccountIdType, serviceId, productID, amount, feeAmount, logo} = data

        //console.log(`destaccountId:${destAccountId} , destAccountIdType:${destAccountIdType},  serviceId:${serviceId}, productID:${productID},  amount:${amount}, feeAmount:${feeAmount}`)

        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().paymentService(data, (result) => {
                    resolve(result)
                }, (error) => {
                    reject(error)
                })
            } catch (error) {
                reject(error)
            }
        })
    },
    getOCRScanner(isClaroPartner, logo, maxlength) {
        return new Promise((resolve, reject) => {
            try {
                if(isClaroPartner){
                    sdkclaro.getInstance().scanCodeCS(
                        logo.substr(22, logo.length), 
                        maxlength,
                        (result) => {
                            console.log("Succes scan claro socio");
                            resolve(result);
                        },
                        (error) => {
                            console.log(JSON.stringify(error), "Error scan claro socio");
                            reject(error)
                        }
                    );
                } else {
                    sdkclaro.getInstance().executeViewFunctionality(
                        "scanCode",
                        {},
                        (result) => {
                            console.log("Succes scan claro pay");
                            window.newRequetsScanner = true
                            resolve(result)
                        }, (error) => {
                            console.log(JSON.stringify(error), "Error scan claro pay");
                            reject(error)
                        }
                    )
                }
                
            } catch (error) {
                console.log(JSON.stringify(error), "Try error scan");
                reject(error)
            }
        })
    },

    getUserInfo() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getProfile(
                    async (result) => {
                        const msisdnEncrypt =  await ClaroSDKService.encrypt(
                            result.msisdn.substr(3, 12)
                          );
                          result.msisdnEncrypt = msisdnEncrypt;
                        return resolve(result);
                    },
                    (error) => {
                        return reject(error.message || "unknow error");
                    }
                );
            } catch (e) {
                return reject(e.message)
            }
        })
    },

    getUserInfoLite() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getUserInfoLite(
                    (result) => {
                        return resolve(result);
                    },
                    (error) => {
                        return reject(error.message || "unknow error");
                    }
                );
            } catch (e) {
                return reject(e.message)
            }
        })
    },

    getCoordinates() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getLocation(
                    (result) => {
                        return resolve(result);
                    },
                    (error) => {
                        return reject(error.message || "unknow error");
                    }
                );
            } catch (e) {
                return reject(e.message)
            }
            return resolve()
        })
    },

    async getTrackId(userInfo) {
        const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();

        const urlParam = new URLSearchParams(window.location.search);
        const bundleId = urlParam.get("bundleId");
        if (!bundleId || (bundleId !== "com.telcel.contenedor.uat" && bundleId !== "com.telcel.contenedor")) {
            const coordinates = await ClaroSDKService.getCoordinates();
            coordinates ? coords = coordinates : coords;
        }
        return new Promise((resolve, reject) => {
            try {
                const url = `https://apps.claropay.com:11616/prod-TrackTransaction/tracktransactionid/init?bundleVersion=3.60.04&claroId=${userInfoValue.username}&latitude=${coords.latitude}&longitude=${coords.longitude}&msisdn=${userInfoValue.msisdn.slice(-10)}&platformIT=WEB&platformITVersion=15&typeOperation=PMT-SER`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                })
                .then(function(response) {
                    return response.json();
                })
                .then(function(data) {
                    return resolve(data.trackTxId);
                })
                .catch(function(err) {
                    console.log(err)
                });
            } catch(error) {
                console.log(error);
            }
        })
    },

    async setTxData(trackTxId, userInfo) {
        const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().transactionData(
                    trackTxId,
                    userInfoValue.msisdn.slice(-10),
                    userInfoValue.username,
                    'PMT-SER',
                    coords.latitude,
                    coords.longitude,
                    '3.60.04',
                    (result) => {
                        console.log(result)
                        return resolve(result);
                    },
                    (error) => {
                        console.log(error)
                        return reject(error)
                    }
                );
            } catch(e) {
                return reject(e)
            }
        })
    },

    async postTrack(trackTxId, step, resp, data, userInfo) {
        if(trackTxId) {
            const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
            return new Promise((resolve, reject) => {
                try {
                    const url = `https://apps.claropay.com:11616/prod-TrackTransaction/track`;
                    const date = new Date().getTime();
                    const jsonConvert = {
                        trackTxId: trackTxId,
                        msisdn: userInfoValue.msisdn.slice(-10),
                        claroId: userInfoValue.username,
                        operationType: 'PMT-SER',
                        date: date,
                        step: step,
                        amount: data ? data.amount: null,
                        commissionAmount: resp ? resp.data.serviceCommission.total : null,
                        externalInvocationResponse: {
                            httpCode: null,
                            cpCode: resp ? resp.responseStatus.code : null,
                            message: resp ? resp.responseStatus.responseMessage : null,
                            description: resp ? resp.responseStatus.desc : null,
                            executionTime: null,
                            provider: null,
                            service: null,
                            operation: resp ? resp.responseStatus.tokenOperation : null,
                            executionSuccess: null,
                            originatorTransactionId: null,
                            responseTransactionId: null,
                            request: null,
                            url: data ? data.url : null,
                            rawRequest: null,
                            rawResponse: null,
                            httpMethod: null
                        },
                        localErrorInfo: null,
                        executionSuccess: null,
                        associate: null,
                        target: null,
                        targetType: null,
                        methodPayment: null,
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                        bundleVersion: '3.60.04',
                        serviceId: data ? data.serviceId : null,
                        merchantId: null,
                        storeID: null,
                        executionTime: null,
                        ip: null,
                        userAgent: null,
                        channel: null,
                        alphanumericReference: null,
                        numericReference: null,
                        transactionid: null,
                        platformType: null,
                        productId: null,
                        paymentType: null,
                        authorizationId: null,
                        transferAuthorizationIdCancel: null,
                        auditNumber: null,
                        cardNumberLastDigits: null,
                        chargeStatus: null,
                        cancelStatus: null,
                        sdkCPVersion: null,
                        cardEmisor: null,
                        businessRuleSuccess: true,
                        platformIT: 'WEB',
                        platformITVersion: '15',
                        businessRuleDescription: null
                    }
                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            't1': trackTxId,
                            't2': step
                        },
                        body: JSON.stringify({"value": `${btoa(JSON.stringify(jsonConvert))}`})
                    })
                    .then(function(response) {
                        console.log(response)
                    })
                    .then(function(data) {
                        console.log(data)
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
                } catch(error) {}
            })
        } else { return }
    },

    getPaymentContacts() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().executeViewFunctionality(
                    "getContacts",
                    {},
                    (result) => {
                        //alert("get contactos" + JSON.stringify(result, null, 2))
                        const contacts = uniqueBy(trimMobileNumber(JSON.parse(b64DecodeUnicode(result.data)))
                            , 'mobileNumber')
                        return resolve(contacts)
                    }, (error) => {
                        console.log(error, "Contacts error")
                        return reject(error)
                    }
                )
            } catch (error) {
                console.log(error, "Catch contact error")
                reject(error)
            }
        })
    },
    /* add favorite, delete favorite , get favorites */
    async getFavoriteContacts(serviceId, userInfo) {
        return new Promise(async (resolve, reject) => {
            try {
                const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
                const { username } = userInfoValue;
                return sdkclaro.getInstance().getFavorites(username, serviceId, 200,
                    result => {
                        //alert(" get favoritos" + JSON.stringify(result, null, 2))

                        let arrayResult = [];
                        for (let key in result) {
                            let splitData = result[key].id.split("_");

                            arrayResult.push({
                                "displayName": splitData[0],
                                "mobileNumber": splitData[1],
                                "isFavorite": true
                            })
                        }
                        return resolve(arrayResult);
                    }
                    , (error) => {
                        return reject(error)
                    }
                )

            } catch (error) {

            }
        })
    },
    async addFavorite(contactInfo) {
        let { fullName, telephoneNumber } = contactInfo.contactInfo;
        let { serviceId } = contactInfo;
        let id = fullName + "_" + telephoneNumber;
        const userInfo = await ClaroSDKService.getUserInfo();

        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().addFavorites(
                    userInfo.username,
                    serviceId,
                    fullName,
                    id,
                    (result) => {
                        //alert("agrego" + JSON.stringify(result, null, 2))

                        return resolve(result);
                    },
                    (error) => {
                        return reject(error);
                    }
                )
            } catch (error) {
                return reject(error);
            }
        });
    },
    async deleteFavoriteContact(contactInfo) {
        const userInfo = await ClaroSDKService.getUserInfo();
        let { fullName, telephoneNumber } = contactInfo.contactInfo;
        let { serviceId } = contactInfo;
        let id = fullName + "_" + telephoneNumber;
        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().removeFavorites(
                    userInfo.username,
                    serviceId,
                    id,
                    (res) => {
                        return resolve(res)
                    },
                    (err) => {
                        return reject(err);
                    }
                );
            } catch (error) {
                reject(error);
            }
        })
    },

    async getFavoriteServices(requestInfo,userInfo) {
        return new Promise(async (resolve, reject) => {
            try {
                // const userInfo = await ClaroSDKService.getUserInfo();
                const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
                const { username } = userInfoValue;
                const {lidApp,query} = requestInfo
                return sdkclaro.getInstance().getFavoriteServices(query, username, lidApp,
                    result => {
                        //alert(" get favoritos" + JSON.stringify(result, null, 2))

                        // let arrayResult = [];
                        // for (let key in result) {
                        //     let splitData = result[key].id.split("_");
                        //     console.log(splitData)

                        //     // //arrayResult.push({
                        //     //     "displayName": splitData[0],
                        //     //     "mobileNumber": splitData[1],
                        //     //     "isFavorite": true
                        //     // })
                        // }
                        return resolve(result);
                    }
                    , (error) => {
                        console.log(error, "getFavoriteServices catch 1");
                        return reject(error)
                    }
                )

            } catch (error) {
                console.log(error, "getFavoriteServices catch");
            }
        })
    },
    async addFavoriteServices(request) {
        let { accountService, alias } = request.contactInfo;
        let { lidApp,lidFavorite } = request;
        const userInfo = await ClaroSDKService.getUserInfo();

        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().createFavoriteServices(
                    userInfo.username,
                    accountService,
                    lidApp,
                    alias,
                    lidFavorite,
                    false,
                    (result) => {
                        //alert("agrego" + JSON.stringify(result, null, 2))
                     console.log(result);
                        return resolve(result);
                    },
                    (error) => {
                        return reject(error);
                    }
                )
            } catch (error) {
                return reject(error);
            }
        });
    },
    async deleteFavoriteServices(request) {
        let { lidFavorite, isActive } = request;
        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().deleteFavoriteServices(
                    lidFavorite,
                    isActive,
                    (res) => {
                        console.log(res);
                        return resolve(res)
                    },
                    (error) => {
                        return reject(error);
                    }
                );
            } catch (error) {
                reject(error);
            }
        })
    },

    async createFavoriteTooltip(request) {
        let { lidApp,userInfo } = request;
        const lidPerson = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().createFavoriteTooltip(
                    lidPerson.username,
                    lidApp,
                    (res) => {
                        console.log(res);
                        return resolve(res)
                    },
                    (error) => {
                        return reject(error);
                    }
                );
            } catch (error) {
                reject(error);
            }
        })
    },

    async getFavoriteTooltip(request) {
        let { lidApp,userInfo } = request;
        const lidPerson = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().getFavoriteTooltip(
                    lidPerson.username,
                    lidApp,
                    (res) => {
                        console.log(res);
                        return resolve(res)
                    },
                    (error) => {
                        return reject(error);
                    }
                );
            } catch (error) {
                reject(error);
            }
        })
    },


    async getRecentContacts(serviceId) {
        const userInfo = await ClaroSDKService.getUserInfo();
        return new Promise(async (resolve, reject) => {
            try {

                return sdkclaro.getInstance().getRecent(
                    userInfo.username, 
                    serviceId, 
                    5,
                    (result) => {
                        let arrayResult = [];
                        for (let key in result) {
                            let splitData = result[key].id.split("_");

                            arrayResult.push({
                                "displayName": splitData[0],
                                "mobileNumber": splitData[1],
                                "isFavorite": false
                            })
                        }
                         console.log(arrayResult, "son los recientes");
                        return resolve(arrayResult);
                    }
                    , (error) => {
                        return reject(error)
                    }
                )
            } catch (error) {

            }
        })
    },

    async addContactToRecents(contactInfo) {
        let { fullName, telephoneNumber } = contactInfo.contactInfo;
        let { serviceId } = contactInfo;
        let id = fullName + "_" + telephoneNumber;
        const userInfo = await ClaroSDKService.getUserInfo();
        return new Promise((resolve, reject) => {
            try {
                return sdkclaro.getInstance().addRecent(
                    userInfo.username,
                    serviceId,
                    fullName,
                    id,
                    (result) => {
                        return resolve(result);
                    },
                    (error) => {
                        return reject(error);
                    }
                )
            } catch (error) {
                return reject(error);
            }
        });
    },

    getAmountOfTelcelPospago(telephoneNumber, serviceId) {
        return new Promise((resolve, reject) => {
            

            try {
                sdkclaro.getInstance().checkBalance(
                    serviceId,
                    telephoneNumber,
                    (result) => {
                        const {
                            responseCode, responseMessage,
                            pendingAmount, responseSubject,
                            messageType, inquiryTelmexId,
                            cutoffDate, lastPaymentDate
                        } = result
                        return resolve({
                            responseCode,
                            responseMessage,
                            pendingAmount,
                            responseSubject,
                            messageType,
                            inquiryTelmexId,
                            cutoffDate,
                            lastPaymentDate
                        })
                    }, (error) => {
                        console.log(JSON.stringify(error), "check balance error");
                        const errorResponse = error.error.description;
                        return reject({
                            responseCode:errorResponse.responseCode,
                            responseMessage: errorResponse.responseMessage,
                            pendingAmount: errorResponse.pendingAmount,
                            responseSubject: errorResponse.responseSubject,
                            messageType: errorResponse.messageType,
                            inquiryTelmexId: errorResponse.inquiryTelmexId
                        });
                    }
                )
            } catch (error) {
                console.log(error, "check balance catch");
            }
        })
    },



    async getPaymentMethods(
        canSendId, 
        hasCredit, 
        serviceId, 
        isClaroPartner, 
        canSendClaroSocioValue,
        userInfo
    ) {
        const userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
        //console.log(userInfoValue, 'userinfo-payment')
        return new Promise((resolve, reject) => {
            try {
                if(canSendId && hasCredit){
                    if(canSendClaroSocioValue){
                        //validar si en algun momento se respetara la bandera o siempre van amarrados serviceId y clarosocio
                        sdkclaro.getInstance().searchCard(
                            {
                                appVersion: "1.0",
                                externalId: "08497FFD-8BA5-4E31-860F-75A105D59627",
                                latitude: "122.53",
                                longitude: "675.82",
                                msisdn: userInfoValue.msisdn.slice(-10),
                                claroId: userInfoValue.username,
                                serviceId: serviceId,
                                isClaroSocio: isClaroPartner
                            },
                            (result) => {
                                //result = {...result, hasN2: false}
                                console.log("search card success");
                                return resolve(result)
                            }, 
                            (error) => {
                                console.log(error, "search card error");
                                return reject(error)
                            }
                        )
                    }else{
                        sdkclaro.getInstance().searchCard(
                            {
                                appVersion: "1.0",
                                externalId: "08497FFD-8BA5-4E31-860F-75A105D59627",
                                latitude: "122.53",
                                longitude: "675.82",
                                msisdn: userInfoValue.msisdn.slice(-10),
                                claroId: userInfoValue.username,
                                serviceId: serviceId,
                            },
                            (result) => {
                                //result = {...result, hasN2: false}
                                console.log("search card success");
                                return resolve(result)
                            }, 
                            (error) => {
                                console.log(error, "search card error");
                                return reject(error)
                            }
                        )
                    }
                } else {
                    sdkclaro.getInstance().searchCard(
                        {
                            appVersion: "1.0",
                            externalId: "08497FFD-8BA5-4E31-860F-75A105D59627",
                            latitude: "122.53",
                            longitude: "675.82",
                            msisdn: userInfoValue.msisdn.slice(-10),
                            claroId: userInfoValue.username,
                            serviceId: serviceId
                        },
                        (result) => {
                            //result = {...result, hasN2: false}
                            console.log("search card success");
                            return resolve(result)
                        }, 
                        (error) => {
                            console.log(error, "search card error");
                            return reject(error)
                        }
                    )
                }
            } catch (error) {
                console.log(error, "search card catch");
               return reject(error)
            }
        })
    },

    async getCommissionRules(
        serviceId,
        amountValueForCommission,
        mark,
        selectCardId,
        cardType,
        sdkVersion

    ) {
        console.log(sdkVersion, "sdkVersion--");
        const userInfo = await ClaroSDKService.getUserInfo();
        const appVersion = (sdkVersion)?"3.14": "2.0.148";
        console.log(appVersion, "appVersion--");
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getRulesServicesPaymentCommission(
                    appVersion,
                    "MEzcgARqaAEQ1dqIoXlefGeYaqfxVrD2",
                    "18.84225640964744",
                    "-99.21713536035762",
                    userInfo.msisdn.slice(-10),
                    "Claro Pay",
                    serviceId,
                    "1599143929417",
                    (result) => {
                        console.log("comision rules success");
                        result = calculateCommissions(
                            result,
                            amountValueForCommission, 
                            mark,
                            selectCardId,
                            cardType
                        )

                        return resolve(result)
                    }, (error) => {
                        console.log(JSON.stringify(error), "comision rules error");
                        return reject(error)
                    }
                )
            } catch (error) {
                console.log(error, "check balance catch");
            }
        })
    },

    async getPlans(serviceId, planType) {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getPlans(
                    planType,
                    serviceId,
                    (result) => {
                        console.log("get plans success");
                        return resolve(result.data[0])
                    }, 
                    (error) => {
                        console.log(error, "get plans error");
                        return reject(error)
                    }
                )
            } catch (error) {
                console.log(error, "get plans catch");
               return reject(error)
            }
        })
    },
    
    async existCardSears(cardNumber, serviceId) {
        
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getBalances(
                    serviceId,
                    cardNumber,
                    (result) => {
                        console.log(result, "exist card sears success", serviceId, cardNumber);
                        resolve(result)
                        
                    },
                    (error) => {
                        console.log(error, "exist card sears error",  serviceId, cardNumber);
                        reject(error)
                    }
                );
            } catch (error) {
                console.log(error, "exist card sears catch");
            }
        })
    },

    async getPlansCardSears(cardSearsNumber, serviceId) {
        return new Promise((resolve, reject) => {
            try {
              sdkclaro.getInstance().getBalances(
                "245",
                cardSearsNumber,
                (result) => {
                  console.log(result, "planes sears success");
                  resolve(result)
                },
                (error) => {
                  console.log(error, "get planes sears error");
                  reject(error)
                }
              );
            } catch (error) {
                console.log(error, "error get planes sears catch");
            }
        })
    },

    async encrypt(text) {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getEncryptData(
                    text,
                    (result) => {
                        console.log("encrypt success");
                        resolve(result);
                    },
                    (error) => {
                        console.log(error, "encrypt error");
                        reject(error)
                    }
                )
            } catch (e) {
                console.log(e, "encript catch");
                return reject(e)
            }
        })
    },

    async executeTaggeo(params, canEncript, userInfo) {
        const  userInfoValue = userInfo ? userInfo : await ClaroSDKService.getUserInfo();
        const {eventName} = params
        params.claro_id = userInfoValue.username;
        params.msisdn = canEncript ? userInfoValue.msisdnEncrypt.data : userInfoValue.msisdn.substr(-10)
        params.eventName = eventName?eventName:"pay_service_or_tae"
        console.log(params, "Enviado a metricas");
        const url = {
            app: "sendAnalytics",
            parameters: JSON.stringify(params),
        };

        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().openNative(
                    JSON.stringify(url),
                    (data) => console.log(data, "TAGGEO success"),
                    (err) => console.log(err, "TAGGEO error"),
                );
            } catch (error) {
                console.log(error, "Error taggeo");
            }
        })
    },

    messagerService(flux, code) {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getMessaging(
                    flux,
                    code,
                    (result) => {
                        console.log(result, "Message success");
                        resolve(result);
                    },
                    (error) => {
                        console.log(error, "Message error");
                        reject(error)
                    }
                )
            } catch (e) {
                console.log(e, "encript catch");
                return reject(e)
            }
        })
    },
    messagerServiceSears(flux, code) {
        console.log(flux, code, "FLUJO en el sdk");
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getMessaging(
                    flux,
                    code,
                    (result) => {
                        console.log("Message success");
                        resolve(result);
                    },
                    (error) => {
                        console.log(error, "Message error");
                        reject(error)
                    }
                )
            } catch (e) {
                console.log(e, "encript catch");
                return reject(e)
            }
        })
    },

    getFullToken() {
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getTokenOauthComplete(
                    (result) => {
                        console.log("Token full success");
                        resolve(result);
                    },
                    (error) => {
                        console.log("Token full error");
                        reject(error);
                    }
                )
            } catch (error) {
                console.log("Token full catch");
                reject(error);
            }
        })
    },

    messagerServiceFavoriteServices(flux, code) {
      
        return new Promise((resolve, reject) => {
            try {
                sdkclaro.getInstance().getMessaging(
                    flux,
                    code,
                    (result) => {
                        
                        resolve(result);
                        console.log(result,"Message favoritos success")
                    },
                    (error) => {
                        
                        reject(error)
                    }
                )
            } catch (e) {
                console.log(e, "encript catch");
                return reject(e)
            }
        })
    },

    openLogin(msisdn="") {
        console.log('Entra openLogin')

        let parameters = {
            requestCode: "loggued_in_response", 
            msisdn: msisdn
        }

        console.log('Params openLogin: ', parameters);

        const url = {
            app: "startEventNoClose",
            to: "openLogin",
            parameters: JSON.stringify(parameters)
        }

        sdkclaro.getInstance().openNative(
            JSON.stringify(url),
            () => {},
            () => {},
        );
    },

    async openOnBoarding() {
        console.log('Entra openOnBoarding');

        const userInfoValue = await ClaroSDKService.getUserInfo();

        let { msisdn } = userInfoValue;
        msisdn = msisdn.slice(-10);

        let parameters = {
            microAppId: "openOnBoarding",
            msisdn: msisdn
        }

        console.log('Params openOnBoarding: ', parameters);

        const url = {
            app: "startEvent",
            to: "openOnBoarding",
            parameters: JSON.stringify(parameters)
        }

        sdkclaro.getInstance().openNative(
            JSON.stringify(url),
            () => {},
            () => {},
        );
    },

    openInvitation() {
        console.log('Entra openInvitation');      

        let parameters = {
            microAppId: "openInvitation",
        }

        console.log('Params openInvitation: ', parameters);

        const url = {
            app: "startEvent",
            to: "openInvitation",
            parameters: JSON.stringify(parameters)
        }

        sdkclaro.getInstance().openNative(
            JSON.stringify(url),
            () => {},
            () => {},
        );
    }
}

